import React, { useState } from 'react';
import { Formik, Form, Field } from 'formik';
import TitleMain from "../../components/Title/TitleMain";
import AxiosConfig from "../../services/AxiosConfig";
import {handleSubmitLogoEntreprise} from "../../services/FileService";


const UploadFileTestPage = props => {

    return (
        <div className="content">
            <TitleMain text={"Test de l'upload d'image"}/>

            <Formik
                initialValues={{ file: null }}
                onSubmit={handleSubmitLogoEntreprise}
            >
                {({ setFieldValue, isSubmitting, errors }) => (
                    <Form>
                        <label htmlFor="file">Choisir un fichier</label>
                        <input
                            id="file"
                            name="file"
                            type="file"
                            onChange={(event) => {
                                setFieldValue("file", event.currentTarget.files[0]);
                            }}
                        />
                        {errors.file ? <div style={{ color: 'red' }}>{errors.file}</div> : null}

                        <button type="submit" disabled={isSubmitting}>
                            Envoyer
                        </button>
                    </Form>
                )}
            </Formik>
        </div>
    );
}


export default UploadFileTestPage;